/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EndCustomerContact } from '../models/end-customer-contact';


/**
 * End Customer Contacts API
 */
@Injectable({
  providedIn: 'root',
})
export class EndCustomerContactsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getEndCustomerContacts
   */
  static readonly GetEndCustomerContactsPath = '/end-customers/{end_customer_id}/contacts';

  /**
   * Get contacts for an end customer.
   *
   * Get contacts for an end customer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEndCustomerContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEndCustomerContacts$Response(params: {
    end_customer_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<EndCustomerContact>>> {

    const rb = new RequestBuilder(this.rootUrl, EndCustomerContactsService.GetEndCustomerContactsPath, 'get');
    if (params) {
      rb.path('end_customer_id', params.end_customer_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EndCustomerContact>>;
      })
    );
  }

  /**
   * Get contacts for an end customer.
   *
   * Get contacts for an end customer
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEndCustomerContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEndCustomerContacts(params: {
    end_customer_id: number;
    context?: HttpContext
  }
): Observable<Array<EndCustomerContact>> {

    return this.getEndCustomerContacts$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EndCustomerContact>>) => r.body as Array<EndCustomerContact>)
    );
  }

  /**
   * Path part for operation createEndCustomerContact
   */
  static readonly CreateEndCustomerContactPath = '/end-customers/{end_customer_id}/contacts';

  /**
   * Create a contact for an end customer.
   *
   * Create a contact for an end customer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEndCustomerContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEndCustomerContact$Response(params: {
    end_customer_id: number;
    context?: HttpContext
    body: EndCustomerContact
  }
): Observable<StrictHttpResponse<EndCustomerContact>> {

    const rb = new RequestBuilder(this.rootUrl, EndCustomerContactsService.CreateEndCustomerContactPath, 'post');
    if (params) {
      rb.path('end_customer_id', params.end_customer_id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EndCustomerContact>;
      })
    );
  }

  /**
   * Create a contact for an end customer.
   *
   * Create a contact for an end customer
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createEndCustomerContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEndCustomerContact(params: {
    end_customer_id: number;
    context?: HttpContext
    body: EndCustomerContact
  }
): Observable<EndCustomerContact> {

    return this.createEndCustomerContact$Response(params).pipe(
      map((r: StrictHttpResponse<EndCustomerContact>) => r.body as EndCustomerContact)
    );
  }

  /**
   * Path part for operation getEndCustomerContact
   */
  static readonly GetEndCustomerContactPath = '/end-customers/{end_customer_id}/contacts/{id}';

  /**
   * Get one contact.
   *
   * Get one contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEndCustomerContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEndCustomerContact$Response(params: {
    end_customer_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<EndCustomerContact>> {

    const rb = new RequestBuilder(this.rootUrl, EndCustomerContactsService.GetEndCustomerContactPath, 'get');
    if (params) {
      rb.path('end_customer_id', params.end_customer_id, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EndCustomerContact>;
      })
    );
  }

  /**
   * Get one contact.
   *
   * Get one contact
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEndCustomerContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEndCustomerContact(params: {
    end_customer_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<EndCustomerContact> {

    return this.getEndCustomerContact$Response(params).pipe(
      map((r: StrictHttpResponse<EndCustomerContact>) => r.body as EndCustomerContact)
    );
  }

  /**
   * Path part for operation updateEndCustomerContact
   */
  static readonly UpdateEndCustomerContactPath = '/end-customers/{end_customer_id}/contacts/{id}';

  /**
   * Update one contact.
   *
   * Update one contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEndCustomerContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEndCustomerContact$Response(params: {
    end_customer_id: number;
    id: number;
    context?: HttpContext
    body: EndCustomerContact
  }
): Observable<StrictHttpResponse<EndCustomerContact>> {

    const rb = new RequestBuilder(this.rootUrl, EndCustomerContactsService.UpdateEndCustomerContactPath, 'put');
    if (params) {
      rb.path('end_customer_id', params.end_customer_id, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EndCustomerContact>;
      })
    );
  }

  /**
   * Update one contact.
   *
   * Update one contact
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateEndCustomerContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEndCustomerContact(params: {
    end_customer_id: number;
    id: number;
    context?: HttpContext
    body: EndCustomerContact
  }
): Observable<EndCustomerContact> {

    return this.updateEndCustomerContact$Response(params).pipe(
      map((r: StrictHttpResponse<EndCustomerContact>) => r.body as EndCustomerContact)
    );
  }

  /**
   * Path part for operation deleteEndCustomerContact
   */
  static readonly DeleteEndCustomerContactPath = '/end-customers/{end_customer_id}/contacts/{id}';

  /**
   * Delete the contact.
   *
   * Delete the contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEndCustomerContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEndCustomerContact$Response(params: {
    end_customer_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, EndCustomerContactsService.DeleteEndCustomerContactPath, 'delete');
    if (params) {
      rb.path('end_customer_id', params.end_customer_id, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete the contact.
   *
   * Delete the contact
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteEndCustomerContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEndCustomerContact(params: {
    end_customer_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.deleteEndCustomerContact$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
